export default __webpack_public_path__ + "static/media/06_dell.55d34c5c.png";